export const CookiePolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-background text-foreground">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-4">Cookie Policy</h1>
        <p className="text-sm text-muted-foreground mb-2">
          <strong>Company:</strong> Realise Property Maintenance Ltd. trading as "Sortable"
        </p>
        <p className="text-sm text-muted-foreground mb-2">
          <strong>Address:</strong> 13 Harbury Rd. Henleaze Business Centre, Henleaze, Bristol, BS9 4PN
        </p>
        <p className="text-sm text-muted-foreground mb-4">
          <strong>Telephone:</strong> 08000438880
        </p>
        <p className="text-sm text-muted-foreground">
          <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
        </p>
      </div>

      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-3">1. What Are Cookies</h2>
          <p className="mb-3">
            Cookies are small text files that are placed on your device when you visit our website. 
            They help us provide you with a better user experience by remembering your preferences 
            and analyzing how you use our platform.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">2. Types of Cookies We Use</h2>
          
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-medium mb-2">2.1. Essential Cookies</h3>
              <p className="mb-2">These cookies are necessary for the platform to function properly:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Authentication cookies to keep you logged in</li>
                <li>Security cookies to protect against fraud</li>
                <li>Load balancing cookies for performance</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">2.2. Functional Cookies</h3>
              <p className="mb-2">These cookies enhance your user experience:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Preference settings (language, location)</li>
                <li>Form data to avoid re-entry</li>
                <li>Chat widget functionality</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">2.3. Analytics Cookies</h3>
              <p className="mb-2">These cookies help us understand how users interact with our platform:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Page view tracking</li>
                <li>User journey analysis</li>
                <li>Performance monitoring</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">2.4. Marketing Cookies</h3>
              <p className="mb-2">These cookies are used for targeted advertising (with your consent):</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Social media integration</li>
                <li>Advertising campaign tracking</li>
                <li>Retargeting cookies</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">3. Cookie Duration</h2>
          <div className="space-y-2">
            <p>3.1. <strong>Session Cookies:</strong> Deleted when you close your browser</p>
            <p>3.2. <strong>Persistent Cookies:</strong> Remain on your device for a set period or until deleted</p>
            <p>3.3. <strong>Third-party Cookies:</strong> Set by external services we use</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">4. Managing Your Cookie Preferences</h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-medium mb-2">4.1. Browser Settings</h3>
              <p className="mb-2">You can control cookies through your browser settings:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Block all cookies</li>
                <li>Block third-party cookies</li>
                <li>Delete existing cookies</li>
                <li>Receive notifications when cookies are set</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">4.2. Our Cookie Banner</h3>
              <p className="mb-2">
                When you first visit our site, you'll see a cookie banner where you can:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Accept all cookies</li>
                <li>Reject non-essential cookies</li>
                <li>Customize your preferences</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">5. Third-Party Cookies</h2>
          <p className="mb-3">
            We may use third-party services that set their own cookies:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Google Analytics:</strong> Website usage analysis</li>
            <li><strong>Stripe:</strong> Payment processing</li>
            <li><strong>Supabase:</strong> Backend services</li>
            <li><strong>Mapbox:</strong> Location services</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">6. Impact of Disabling Cookies</h2>
          <p className="mb-3">
            Disabling cookies may affect your experience on our platform:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>You may need to log in repeatedly</li>
            <li>Preference settings may not be saved</li>
            <li>Some features may not work properly</li>
            <li>We cannot provide personalized content</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">7. Updates to This Policy</h2>
          <p className="mb-3">
            We may update this Cookie Policy to reflect changes in our practices or applicable laws. 
            We will notify you of any significant changes by updating the "Last Updated" date.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">8. Contact Information</h2>
          <div className="space-y-2">
            <p>For questions about our use of cookies, please contact us:</p>
            <p><strong>Email:</strong> privacy@sortable.co.uk</p>
            <p><strong>Phone:</strong> 08000438880</p>
            <p><strong>Address:</strong> 13 Harbury Rd. Henleaze Business Centre, Henleaze, Bristol, BS9 4PN</p>
          </div>
        </section>
      </div>
    </div>
  );
};